import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = {
  class: "gs_item"
};
const _hoisted_3 = {
  class: "gs_left"
};
const _hoisted_4 = {
  class: "gs_right"
};

const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "添加规格", -1);

import DynamicParams from "@com/DynamicParams.vue";
import { reactive, ref, onMounted, watch } from "vue";
import Sortable from "sortablejs";
import $ from "@util/base";
import { $msg } from "@/common/ui/msg";
const type1 = "1008001";
const type2 = "1008002";
const type3 = "1008003";
export default {
  __name: 'LineSpecs',
  props: {
    data: {
      type: Object
    },
    specs: {
      type: Array
    },
    // data: {type: Array, default: () => []},
    readOnly: {
      type: Boolean,
      default: false
    },
    travelProgramme: {
      type: Array
    }
  },

  setup(__props, {
    expose: __expose
  }) {
    function hadnerSpecsData(value) {
      console.log("value" + value);

      if ($.isNotEmpty(value)) {
        return value.map(e => {
          return {
            value: e,
            oldValue: e
          };
        });
      } else {
        return [];
      }
    }

    const props = __props;
    const template = {
      detailType: null,
      detailTitle: null,
      startTime: null,
      hotelItems: props.travelProgramme
    };
    watch(() => props.data, val => {
      if ($.isNotEmpty(val)) {
        routeData.value = val;
      }
    });
    watch(() => props.travelProgramme, val => {
      template.hotelItems = $.deepCopy(val);
    });
    const routeData = ref(props.data);

    function operation(readOnly) {
      if (readOnly) {
        return {
          move: false,
          modify: false,
          del: false,
          add: true,
          check: false
        };
      } else {
        return {
          move: true,
          modify: false,
          del: true,
          add: false,
          check: false
        };
      }
    }

    function initData() {
      if ($.isNotEmpty(props.data)) {
        return props.data.map(e => {
          e.tempId = $.uuid8();
          return e;
        });
      } else {
        return [];
      }
    }

    if ($.isEmpty(props.data)) {
      addAttr();
    }

    const routeDetailsView = ref([]);

    function delDay(id) {
      routeData.value.remove(e => {
        return e.tempId === id;
      });

      if (id == curDay.value.tempId) {
        if (routeData.value.length > 0) {
          curDay.value = routeData.value[0];
        } else {
          curDay.value = [];
        }
      }

      routeData.value.map((e, i) => {
        e.num = i + 1;
      });
    }

    function addAttr() {
      let template = {
        typeAttr: null,
        typeAttrValues: [{
          value: null
        }],
        num: routeData.value.length + 1,
        tempId: $.uuid8(),
        typeAttrItemList: []
      };
      routeData.value.push(template);
    }

    var curDay = reactive({
      value: routeData.value[0]
    });
    var lastDay = routeData.value[0];

    function getValue() {
      // let routeDetails = routeDetailsView.value.getValue();
      // if ($.isEmpty(routeDetails)) {
      //   return null;
      // }
      let result = [];

      if ($.isNotEmpty(routeDetailsView.value)) {
        routeData.value.forEach((e, index) => {
          let obj = {
            typeAttr: e.typeAttr
          };

          if (routeDetailsView.value[index].getValue() != null) {
            obj.typeAttrValues = routeDetailsView.value[index].getValue().map(e => {
              return e.value;
            });
          }

          result.push(obj);
        });
      }

      return $.deepCopy(result);
    }

    __expose({
      getValue
    });

    return (_ctx, _cache) => {
      const _component_Close = _resolveComponent("Close");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_Plus = _resolveComponent("Plus");

      return _openBlock(), _createElementBlock(_Fragment, null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routeData.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "goods_specs",
          key: item.tempId
        }, [__props.readOnly == false ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "del",
          onClick: _withModifiers($event => delDay(item.tempId), ["stop"])
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Close)]),
          _: 1
        })], 8, _hoisted_1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, "规格" + _toDisplayString(item.num), 1)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input, {
          modelValue: item.typeAttr,
          "onUpdate:modelValue": $event => item.typeAttr = $event,
          placeholder: "请输入"
        }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createVNode(DynamicParams, {
          ref_for: true,
          ref_key: "routeDetailsView",
          ref: routeDetailsView,
          template: {
            value: null
          },
          data: item.typeAttrValues,
          operation: _unref($).DPOperation(__props.readOnly),
          addText: "添加选项"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "选项",
            align: "center"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input, {
              modelValue: scope.row.value,
              "onUpdate:modelValue": $event => scope.row.value = $event,
              placeholder: "请输入",
              disabled: __props.readOnly || _unref($).isNotEmpty(scope.row.oldValue)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
            _: 1
          })]),
          _: 2
        }, 1032, ["data", "operation"])])])]);
      }), 128)), __props.readOnly == false ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "dashed_but",
        onClick: addAttr
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_Plus)]),
        _: 1
      }), _hoisted_5])) : _createCommentVNode("", true)], 64);
    };
  }

};